import { Row, Col, Layout } from 'antd';
import React, { useEffect, useState } from 'react';
import { isValid } from '../../../utils/utilities';
import { BoardingPointForm } from './boarding-point-form.component';
import { getBoadringPointCities } from './boarding-points.module';
import { useDispatch } from 'react-redux'
import { getAddressLocations } from '../../../actions/trip-create.actions';
import { BoardingPointTable } from './boarding-point-table.component';
import './boarding-points.style.scss';

const { Content } = Layout;


export const BoardingPointComponent = (props) => {

  const {
    routes,
    selectedTrip,
    boardingPoints,
    isRowClickable,
    showDeleteUpdateButtons,
    boardingPointsLoading
  } = props;

  const {
    id
  } = selectedTrip;

  const dispatch = useDispatch();
  const [boardingFormData, setBoardingFormData] = useState({});
  const [boardingAddressLocations, setBoardingAddressLocations] = useState([]);

  useEffect(() => {
    if (isValid(routes)) {
      dispatch(getAddressLocations(getBoadringPointCities(routes), true, (data) => { setBoardingAddressLocations(data.addressLocations) }, () => { }));
    }
  }, [routes]);

  return (
    <Layout className="boarding-points-layout">
      <Content>
        <Row type='flex' justify="space-around" className="boarding-points-row">
          <Col xs={24} sm={24} md={24} lg={8} xl={8} className="boarding-points-form-col">
            <BoardingPointForm
              tripId={id}
              boardingAddressLocations={boardingAddressLocations}
              boardingFormData={boardingFormData}
              setBoardingFormData={setBoardingFormData}
              boardingPoints={boardingPoints}
              showDeleteUpdateButtons={showDeleteUpdateButtons}
              selectedTrip={selectedTrip}
              routes={routes}
            />
          </Col>
          <Col xs={24} sm={24} md={24} lg={16} xl={16} className="boarding-points-table-col">
            <BoardingPointTable
              boardingPointsLoading={boardingPointsLoading}
              boardingPoints={boardingPoints}
              isRowClickable={isRowClickable}
              boardingFormData={boardingFormData}
              setBoardingFormData={setBoardingFormData}
            />
          </Col>
        </Row>
      </Content>
    </Layout>

  );
};